import { useLocation } from 'react-router-dom';
import { getCurrentStepCount } from 'services';

export const useGetCurrentStepCount = () => {
  const location = useLocation();

  return getCurrentStepCount(location.pathname);
};
